import type { TError } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Hook to delete a comment
 * Only the comment author can delete their own comments
 *
 * @param postId - Post ID (UUID) the comment belongs to
 * @param commentId - Comment ID (UUID) to delete
 */
export const useDeleteComment = (postId: string, commentId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, TError, void>({
    mutationFn: async () => {
      await axios.delete(`/community-hub/comments/${commentId}`);
    },
    onSuccess: () => {
      // Invalidate comments queries to refresh the list
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'comments', postId] });
      // Also invalidate posts to update comment count
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'posts'] });
    },
  });
};
